import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Define breakpoints for responsiveness
const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px',
};

// Function to calculate line-height based on font size
const calculateLineHeight = (fontSize) => {
  const size = parseInt(fontSize, 10);
  return `${Math.round(size * 1.3)}px`; // Line height multiplier (e.g., 1.4 times the font size)
};

// Function to calculate responsive font size based on the base size
const calculateResponsiveFontSize = (fontSize, multiplier) => {
  const size = parseInt(fontSize, 10);
  return `${Math.round(size * multiplier)}px`;
};

// Create the styled `Typography` component
const StyledTypography = styled.div`
  font-family: 'Gilroy', sans-serif;
  font-size: ${(props) => props.size || '16px'};
  font-weight: ${(props) => props.weight || '400'};
  line-height: ${(props) => calculateLineHeight(props.size || '16px')};
  color: ${(props) => props.color || 'inherit'};
  text-align: ${(props) => props.textAlign || 'left'};

  @media (max-width: ${breakpoints.desktop}) {
    font-size: ${(props) => calculateResponsiveFontSize(props.size || '16px', 0.9)};
    line-height: ${(props) => calculateLineHeight(calculateResponsiveFontSize(props.size || '16px', 0.9))};
  }

  @media (max-width: ${breakpoints.tablet}) {
    font-size: ${(props) => calculateResponsiveFontSize(props.size || '16px', 0.8)};
    line-height: ${(props) => calculateLineHeight(calculateResponsiveFontSize(props.size || '16px', 0.8))};
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: ${(props) => calculateResponsiveFontSize(props.size || '16px', 0.7)};
    line-height: ${(props) => calculateLineHeight(calculateResponsiveFontSize(props.size || '16px', 0.7))};
  }
`;

const Typography = ({ children, size, weight, color, textAlign }) => {
  return (
    <StyledTypography size={size} weight={weight} color={color} textAlign={textAlign}>
      {children}
    </StyledTypography>
  );
};

Typography.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  weight: PropTypes.oneOf(['400', '500', '600', '700']),
  color: PropTypes.string,
  textAlign: PropTypes.string,
};

export default Typography;
